import initialState from '../initialState';

const initialStateObj = {
};

export default function ErrorsReducer(state = initialStateObj, action) {
    switch (action.type) {

        default:
            return state;
    }
}